"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const ng2_dragula_1 = require("ng2-dragula");
const idm_ng_controls_1 = require("@synisys/idm-ng-controls");
/**
 * Chip group controls that will render the passed items as chip list or chip tree.
 * This control will have the possibility to change the order of these elements.
 */
require("./sis-reporting-chip-group.component.css");
const path_processing_helper_1 = require("../../../shared/path-processing-helper");
const reporting_chip_model_factory_1 = require("../model/reporting-chip-model-factory");
let SisReportingChipGroupComponent = class SisReportingChipGroupComponent {
    constructor(dragulaService) {
        this.dragulaService = dragulaService;
        /**
         * Allow select item more than once, default is true
         * @type {boolean}
         */
        this.allowSelectMoreThanOnce = true;
        /**
         * The currency field of the passed items
         * @type {string}
         */
        this.currencyField = 'currencyId';
        /**
         * The width of chip elements
         * @type {number}
         */
        this.width = 150;
        /**
         * Defines the indent of the next level according to previous level
         * @type {number}
         */
        this.indent = 10;
        /**
         * The function that will be called when the items list is changed
         * @type {EventEmitter}
         */
        this.onItemsChange = new core_1.EventEmitter();
        this.onSelectedItemsChange = new core_1.EventEmitter();
        this.clickedItemIndex = -1;
        this._draggableItems = null;
        this.allAvailableItems = [];
    }
    set data(data) {
        this._data = data.slice();
        this.allowSelectMoreThanOnce ? this.filteredData = this._data : this.filterAvailablePathsBySelected();
        this.allAvailableItems = idm_ng_controls_1.initComboBoxOptions(this._data);
        this.selectedItems && (this._draggableItems = this.processItems());
    }
    ngOnInit() {
        this.dragulaService.drop.subscribe((value) => {
            this.onItemsChange.emit(this.chipsItemsToChipModel());
        });
    }
    /**
     * This method will handle all input changes
     * @param {SimpleChange} changes
     * @returns {void}
     * @public
     * @method
     */
    ngOnChanges(changes) {
        if (changes['items'] && this.selectedItems !== this.items) {
            this.selectedItems = this.items;
            this._draggableItems = this.processItems();
        }
    }
    delete(index) {
        this.selectedItems.splice(index, 1);
        this.selectedItems = this.items;
        this.items = this.selectedItems;
        !this.allowSelectMoreThanOnce && this.filterAvailablePathsBySelected();
        this.onSelectedItemsChange.emit(this.selectedItems);
        const draggableItems = this._draggableItems.slice();
        draggableItems.splice(index, 1);
        this.draggableItems = draggableItems;
    }
    click(index, id) {
        this.clickedItemIndex = index;
        this.currentValue = id;
        this.isComboOpened = true;
    }
    get draggableItems() {
        return this._draggableItems;
    }
    set draggableItems(draggableItems) {
        this._draggableItems = draggableItems;
    }
    closeCombobox(isClosed) {
        if (isClosed) {
            this.isComboOpened = false;
        }
    }
    setValue(value) {
        if (value) {
            let selectedMeasures = this.selectedItems.slice();
            let selectedValues = this.draggableItems.slice();
            let path = path_processing_helper_1.createMeasureListItem(value);
            this.clickedItemIndex !== -1 ?
                selectedMeasures[this.clickedItemIndex] = this.reportingChipModelFactory.create(path) :
                selectedMeasures.push(this.reportingChipModelFactory.create(path));
            this.clickedItemIndex !== -1 ?
                selectedValues[this.clickedItemIndex] = path :
                selectedValues.push(path);
            this.items = selectedMeasures;
            this.selectedItems = this.items;
            !this.allowSelectMoreThanOnce && this.filterAvailablePathsBySelected();
            this.onSelectedItemsChange.emit(this.selectedItems);
            this._draggableItems = [];
            this.draggableItems = selectedValues;
        }
    }
    setCurrencyValue(currencyId, index, id) {
        if (currencyId && id && index !== -1) {
            let selectedItems = this.selectedItems.slice();
            if (selectedItems[index].currencyId !== currencyId) {
                selectedItems[index].currencyId = currencyId;
                this.items = selectedItems;
                this.selectedItems = selectedItems;
                this.onSelectedItemsChange.emit(this.selectedItems);
                let draggableItems = this.draggableItems.slice();
                draggableItems[index].currencyId = currencyId;
                this._draggableItems = [];
                this.draggableItems = draggableItems;
            }
        }
    }
    processItems() {
        let processedData = idm_ng_controls_1.initComboOptions(this.selectedItems.map(item => item.id), this.allAvailableItems);
        return processedData.map((value, index) => {
            return path_processing_helper_1.createMeasureListItem(Object.assign({}, value, {
                value: Object.assign({}, value.value, { currencyId: this.selectedItems[index].currencyId })
            }));
        });
    }
    chipsItemsToChipModel() {
        return this.draggableItems.map((item) => {
            return this.reportingChipModelFactory.create(item);
        });
    }
    filterAvailablePathsBySelected() {
        this.filteredData = [];
        this._data.forEach(path => {
            // deep clone elements in group
            this.filteredData.push(Object.assign({}, path));
        });
        if (this.selectedItems && this.selectedItems.length) {
            this.filteredData.forEach(path => {
                path.items = path.items.filter(item => {
                    return this.selectedItems.findIndex(selected => selected.currencyId == null && selected.id === item.value.id) < 0;
                });
            });
        }
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SisReportingChipGroupComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SisReportingChipGroupComponent.prototype, "placeholder", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], SisReportingChipGroupComponent.prototype, "maxCount", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], SisReportingChipGroupComponent.prototype, "items", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], SisReportingChipGroupComponent.prototype, "allowSelectMoreThanOnce", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], SisReportingChipGroupComponent.prototype, "data", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SisReportingChipGroupComponent.prototype, "nameField", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SisReportingChipGroupComponent.prototype, "idField", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SisReportingChipGroupComponent.prototype, "colorField", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SisReportingChipGroupComponent.prototype, "currencyField", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], SisReportingChipGroupComponent.prototype, "isHierarchical", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], SisReportingChipGroupComponent.prototype, "width", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], SisReportingChipGroupComponent.prototype, "indent", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], SisReportingChipGroupComponent.prototype, "hasColor", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", reporting_chip_model_factory_1.ReportingChipModelFactory)
], SisReportingChipGroupComponent.prototype, "reportingChipModelFactory", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], SisReportingChipGroupComponent.prototype, "onItemsChange", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], SisReportingChipGroupComponent.prototype, "onSelectedItemsChange", void 0);
SisReportingChipGroupComponent = __decorate([
    core_1.Component({
        
        selector: "sis-reporting-chip-group-combo",
        template: require('./sis-reporting-chip-group.component.html'),
        styles: [require('./sis-reporting-chip-group.component.css')],
        providers: [ng2_dragula_1.DragulaService]
    }),
    __metadata("design:paramtypes", [ng2_dragula_1.DragulaService])
], SisReportingChipGroupComponent);
exports.SisReportingChipGroupComponent = SisReportingChipGroupComponent;
//# sourceMappingURL=sis-reporting-chip-group.component.js.map